import styles from './login-form.module.scss';
import cx from 'classnames';

import { Button, Icon, IconEnum, InputType } from '@greenkub-fronts/shared/ui';
import useLoginFormFeature from '../../../feature/login-form-feature/login-form-feature';

import { Link } from 'react-router-dom';
import { Form, Input } from 'antd';
import { FormItem } from 'react-hook-form-antd';

export function LoginForm() {
  const {
    handleSubmit,
    onSubmit,
    isPasswordVisible,
    onPasswordVisibleToggle,
    loginErrorMsg,
    isFetching,
    control,
  } = useLoginFormFeature();

  return (
    <Form className={styles['LoginForm']} onFinish={handleSubmit(onSubmit)}>
      <FormItem control={control} name="email">
        <Input size={'large'} type="email" placeholder="Email" />
      </FormItem>

      <FormItem control={control} name="password">
        <Input
          size={'large'}
          type={!isPasswordVisible ? 'password' : 'text'}
          placeholder="Mot de passe"
          suffix={
            <Button
              className={cx(
                styles['LoginToggleVisiblePassword'],
                styles['IconButton']
              )}
              onClick={() => onPasswordVisibleToggle()}
            >
              {!isPasswordVisible ? (
                <Icon name={IconEnum.VISIBILITY} />
              ) : (
                <Icon name={IconEnum.VISIBILITY_OFF} />
              )}
            </Button>
          }
        />
      </FormItem>

      <div className={styles['LoginActions']}>
        <Link
          to="/login/password-forgot"
          style={{
            color: loginErrorMsg ? 'red' : 'black',
            textDecoration: 'underline',
          }}
        >
          Mot de passe oublié ?
        </Link>
      </div>

      <div>
        <p className={cx(styles['FormMsg'], styles['IsError'])}>
          {loginErrorMsg}
        </p>
      </div>

      <Button
        loading={isFetching}
        className={styles['LoginSubmit']}
        inputType={InputType.SUBMIT}
        label="Accéder à mes informations"
      />
    </Form>
  );
}

export default LoginForm;
